import { KeyProvider } from './cin-verifier';

/**
 * MJSP public key used to sign Brazilian CIN (Carteira de Identidade Nacional)
 * QR-code JWTs (ES512 / ECDSA P-521).
 *
 * This is a PUBLIC verification key. It was extracted from the official
 * "Carteira de Identidade Nacional" app (`com.identidadenacional`, by SERPRO)
 * and confirmed to verify genuine CIN QR JWTs (`iss: "MJSP"`). It is shipped as
 * the default so CIN signatures verify out of the box; callers can override it
 * via a {@link KeyProvider} if MJSP rotates the key.
 */
export const MJSP_CIN_PUBLIC_KEY: JsonWebKey = {
  kty: 'EC',
  crv: 'P-521',
  x: 'ADmN2eus6YfvziHBVuc6cKlzWQ4w_hz1sU0c4qYxFFpNVnEw_d6PO_QVl0OQxMo7WxC0okYDqCVtEl9yoRUA3RLK',
  y: 'AFc1lVJVmpLHNNnqXUmFToa6u2l9c_eOOdF6TqAj7chdGtKyqJQAFTWBzVrDQzUj7A4gWE8O3-q-sMm3EnQR3v7O',
};

/** Key provider preloaded with the known MJSP CIN key (overridable). */
export class MjspKeyProvider implements KeyProvider {
  constructor(private readonly key: JsonWebKey | null = MJSP_CIN_PUBLIC_KEY) {}
  async cinPublicKey(): Promise<JsonWebKey | null> {
    return this.key;
  }
}
